import { createFileRoute } from "@tanstack/react-router";

import { GymList } from "@/features/training/modules/gyms/gym-list";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/gyms/")({
  loader: () => ({ crumb: m.gyms_title() }),
  component: GymList,
});
